import { CareerAssessment } from './CareerAssessmentVisual'

export default CareerAssessment
